import { render, staticRenderFns } from "./liveConfig.vue?vue&type=template&id=492684b3&scoped=true"
import script from "./liveConfig.vue?vue&type=script&lang=js"
export * from "./liveConfig.vue?vue&type=script&lang=js"
import style0 from "./liveConfig.vue?vue&type=style&index=0&id=492684b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492684b3",
  null
  
)

export default component.exports